import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8a7c832&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=c8a7c832&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a7c832",
  null
  
)

export default component.exports